import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_ontos_menu_items = _resolveComponent("ontos-menu-items")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_ctx.grouped)
    ? (_openBlock(), _createBlock(_component_v_menu, {
        key: 0,
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.open) = $event)),
        location: "bottom end"
      }, {
        activator: _withCtx(({props}) => [
          _createVNode(_component_v_btn, _mergeProps(props, {
            variant: "text",
            size: "small",
            icon: "mdi-dots-vertical",
            "aria-label": _ctx.$tt('nav.goto')
          }), null, 16, ["aria-label"])
        ]),
        default: _withCtx(() => [
          (_ctx.inside)
            ? (_openBlock(), _createBlock(_component_v_list, {
                key: 0,
                density: "compact",
                "min-width": "200"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-chevron-left",
                    title: _ctx.inside.label,
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.inside = null), ["stop"]))
                  }, null, 8, ["title"]),
                  _createVNode(_component_v_divider, { class: "my-1" }),
                  _createVNode(_component_ontos_menu_items, {
                    items: _ctx.inside.items
                  }, null, 8, ["items"])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_list, {
                key: 1,
                density: "compact",
                "min-width": "200"
              }, {
                default: _withCtx(() => [
                  (_ctx.menus.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: menu.key,
                            "prepend-icon": menu.icon,
                            title: menu.label,
                            "append-icon": "mdi-chevron-right",
                            onClick: _withModifiers(($event: any) => (_ctx.inside = menu), ["stop"])
                          }, null, 8, ["prepend-icon", "title", "onClick"]))
                        }), 128)),
                        _createVNode(_component_v_divider, { class: "my-1" })
                      ], 64))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.destinations, (destination, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: destination.key
                    }, [
                      (_ctx.last(index))
                        ? (_openBlock(), _createBlock(_component_v_divider, {
                            key: 0,
                            class: "my-1"
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_list_item, {
                        to: destination.to,
                        "prepend-icon": destination.icon,
                        title: _ctx.$tt(destination.label)
                      }, null, 8, ["to", "prepend-icon", "title"])
                    ], 64))
                  }), 128))
                ]),
                _: 1
              }))
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.destinations, (destination) => {
        return (_openBlock(), _createBlock(_component_v_btn, {
          key: destination.key,
          to: destination.to,
          variant: "text",
          icon: "",
          exact: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(destination.icon), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_v_tooltip, {
              activator: "parent",
              location: "bottom"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$tt(destination.label)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
}